import { c as _c } from "react/compiler-runtime";
import Button from '../base/Button';
import { StyledCardSection } from '../base/Card';
import Text from '../base/Text';
import Tooltip from '../base/Tooltip';
import CopyableField from '../CopyableField';
import { Div } from '../helpers/StyledUtils';
const MASKED_KEY_VALUE = '*********************************************************';
const UNAUTHORIZED_TOOLTIP = "As a member, you don't have permission to view API Keys. Contact your organization admin for further access.";
interface UnauthorizedApiKeyRowProps {
  grid_values: {
    columns: string;
    gap: number;
  };
  show_project_column?: boolean;
  tooltip?: string;
  'data-testid'?: string;
}

/**
 * Placeholder body row for the API key tables when the viewer can't list keys (the server returns
 * 401/403): a masked name/key with disabled controls, in the same layout as a real row so every
 * role sees the same table shell.
 */
export function UnauthorizedApiKeyRow(t0) {
  const $ = _c(17);
  const {
    grid_values,
    show_project_column: t1,
    tooltip: t2,
    "data-testid": data_testid
  } = t0;
  const show_project_column = t1 === undefined ? false : t1;
  const tooltip = t2 === undefined ? UNAUTHORIZED_TOOLTIP : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      x: 4
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Div min_w={0}><Div p={{
        y: 3
      }}><Text semi={true} size="s" muted={true}>•••••••••••</Text></Div></Div>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== show_project_column) {
    t5 = show_project_column && <Div min_w={0}><Div p={{
        y: 3
      }}><Text size="s" muted={true}>•••••••••••</Text></Div></Div>;
    $[2] = show_project_column;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Div min_w={0}><Div p={{
        y: 3
      }}><Text size="s" muted={true}>•••••••••••</Text></Div></Div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      y: 2
    };
    t8 = {
      align: "center",
      gap: 1
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t7 = $[5];
    t8 = $[6];
  }
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Div min_w={0}><Div p={t7} flex={t8}><CopyableField mono={true} ghost={true} disabled={true} text_size="xs" flex={{
          grow: true
        }} value={MASKED_KEY_VALUE} /><Button icon="view" ghost={true} disabled={true} /><Button icon="horizontal_more" ghost={true} disabled={true} /></Div></Div>;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== grid_values || $[9] !== t5) {
    t10 = <Div grid={grid_values}>{t4}{t5}{t6}{t9}</Div>;
    $[8] = grid_values;
    $[9] = t5;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== tooltip) {
    t11 = <Tooltip fill={true} tooltip={tooltip} side="bottom">{t10}</Tooltip>;
    $[11] = t10;
    $[12] = tooltip;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== data_testid || $[15] !== t11) {
    t12 = <StyledCardSection p={t3} data-testid={data_testid}>{t11}</StyledCardSection>;
    $[14] = data_testid;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}